export enum DocumentCategory {
    consignmentNoteZip = 1,
    preInvoice = 2, // Pas visible en front
    planning = 3,
    officialDocuments = 4,
    export = 5,
    orderDocument = 6, // Pas visible en front
    invoice = 7,
}